import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#263776] text-white flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="max-w-md text-center">
        <img
          src="/api/static/brand/C1_Stacked_White.svg"
          alt="SPAN CasePrime"
          className="mx-auto mb-8"
          style={{ width: "160px", height: "auto", opacity: 0.92 }}
          data-testid="brand-logo-404"
        />
        <div className="font-mono uppercase tracking-[0.22em] text-[11px] text-white/60 mb-3">Error 404</div>
        <h1 className="font-display text-[34px] font-bold tracking-tight leading-none">Page not found.</h1>
        <p className="text-[14px] text-white/70 mt-4 leading-relaxed">
          This page may have moved, the link is broken, or you don&apos;t have access.
          The chain of custody is intact — let&apos;s get you back on track.
        </p>
        <div className="flex items-center justify-center gap-3 mt-8">
          <Link to="/dashboard" className="bg-[#F47D20] text-white px-5 py-3 font-medium text-[13px] hover:bg-[#dd6d17] transition-colors" data-testid="not-found-dashboard">
            Back to dashboard
          </Link>
          <Link to="/" className="border border-white/30 px-5 py-3 font-medium text-[13px] hover:bg-white/10 transition-colors">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
